"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_components_badge_1 = require("@saatva-bits/pattern-library.components.badge");
const pattern_library_components_picture_imgix_1 = require("@saatva-bits/pattern-library.components.picture-imgix");
const ProductImage_module_scss_1 = __importDefault(require("./ProductImage.module.scss"));
const colorMap = {
    'taupe': 'taupe',
    'graphite': 'graphite',
    'natural': 'linen',
    'light indigo': 'light-indigo',
    'indigo / ash': 'indigo',
    'sage / sand': 'sand',
    'white / sand': 'sand',
    'white / ash': 'ash',
    'white / indigo': 'indigo',
    'white / white': 'white'
};
/**
 * Renders the image of a product, uses productCode to build the asset path
 * for said product according to color/fabric is aplicable
 *
 * @param {object} props
 * @param {string} props.productCode
 * @param {string} props.alt - Alt if image doesnt show up
 * @param {string} props.tag - Tag string text
 * @param {string} props.IMGIX_URL - imgix domain url to retrieve image
 * @param {object} props.selectionDeps - Selection context functions used internally
 * @param {import('../../typedefs').UseProductState} props.selectionDeps.useProductState - returns the requested attributes current selected variant
 * @param {import('../../typedefs').UseProductData} props.selectionDeps.useProductData - returns the product data
 */
const ProductImage = ({ productCode, alt, tag, selectionDeps, IMGIX_URL = 'saatva-qa.imgix.net', }) => {
    const { useProductState, useProductData } = selectionDeps;
    const productState = useProductState(productCode, ['color', 'category']);
    const productData = useProductData(productCode);
    let selectedColor = null;
    if (productState && productState.color) {
        selectedColor = productState.color.toLowerCase();
        Object.entries(colorMap).forEach(([key, value]) => {
            if (selectedColor.includes(key)) {
                selectedColor = value;
            }
        });
    }
    const category = productData && productData.category && productData.category.toLowerCase();
    const useSelectedColor = category === 'bedding';
    const colorIsConfigurable = productData && productData.configurableAttributes.includes('color');
    const addColorToName = selectedColor && useSelectedColor && colorIsConfigurable;
    const name = addColorToName ? `${productCode}-${selectedColor}-details.jpg` : `${productCode}-details.jpg`;
    const folder = `category/${category}/${productCode}-details`;
    return ((0, jsx_runtime_1.jsxs)("div", { className: ProductImage_module_scss_1.default.imageContainer, children: [(0, jsx_runtime_1.jsx)(pattern_library_components_picture_imgix_1.Picture, { imgixDomain: IMGIX_URL, imageClassName: ProductImage_module_scss_1.default.image, className: ProductImage_module_scss_1.default.imagePicture, folder: folder, name: name, alt: alt, widths: {
                    mobile: 335,
                    tablet: 328,
                    desktop: 348
                }, prefixOverride: {
                    tablet: 'mobile'
                } }), tag && ((0, jsx_runtime_1.jsx)(pattern_library_components_badge_1.Badge, { text: tag }))] }));
};
ProductImage.propTypes = {
    productCode: prop_types_1.default.string.isRequired,
    selectionDeps: prop_types_1.default.shape({
        useProductState: prop_types_1.default.func.isRequired,
        useProductData: prop_types_1.default.func.isRequired
    }).isRequired,
    IMGIX_URL: prop_types_1.default.string,
    tag: prop_types_1.default.string,
    alt: prop_types_1.default.string
};
exports.default = ProductImage;
//# sourceMappingURL=ProductImage.js.map